import AuthService from '@/services/auth.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import Text from '@/shared-components/text/components/Text';

import './styles/Header.css';

export default function Header({ artworksCount, onBeginClick }) {

  return (
    <>
      <SuarteName className="verify-gallery__suarte-name"/>

      {
        artworksCount >= 3 ?
          <>
            <ContinueButton className="verify-gallery__gallery-profile-verified-button" onClick={onBeginClick}>
                            Begin my journey
            </ContinueButton>

            <div className="verify-gallery__logout-mobile-container">
              <Text className="verify-gallery__logout-mobile-text" small paragraph>
                                Your profile is ready!
              </Text>

              <ContinueButton className="verify-gallery__override-default-font-size" onClick={onBeginClick}>
                                Begin my journey
              </ContinueButton>
            </div>
          </>
          :
          <>
            <button onClick={AuthService.logout} className="verify-gallery__logout-desktop-button">
              <Text className="verify-gallery__logout-desktop-button-text" medium>
                                Log out and continue as guest
              </Text>
            </button>

            <div className="verify-gallery__logout-mobile-container">
              <Text className="verify-gallery__logout-mobile-text" small paragraph>
                                You can log out and come back later. Changes will not be lost.
              </Text>
                            
              <ContinueButton className="verify-gallery__override-default-font-size" onClick={AuthService.logout}>
                                Continue as guest
              </ContinueButton>
            </div>
          </>
      }
    </>
  );
}
